import { useTranslation } from "react-i18next";
import classes from "./SectionDivider.module.css";

export default function SectionDivider({ title, noMargin, children }) {
  const { t } = useTranslation("general");

  const paragraphs = children;
  return (
    <div
      className={`${classes.sectionDivider} ${
        noMargin ? "u-margin_0" : "u-margin--top_500 u-margin--bottom_500"
      }`}
    >
      {children ? (
        <span
          style={{ display: "flex", alignItems: "center", gap: "4px" }}
          className={classes.text}
        >
          {paragraphs}:
        </span>
      ) : (
        <span className={classes.text}>{t(title)}: </span>
      )}
      <span className={classes.line}></span>
    </div>
  );
}
